import {getUserInfo} from '@/api/user'

const SET_STATE = 'SET_STATE';

const defaultState = {
  anonymous: true, // не авторизованный пользователь
  authorized: false, // авторизованный пользователь
  authToken: null, // токен авторизации
  hasLicense: false, // есть лицензия
};

const store = {
  namespaced: true,
  state: defaultState,
  mutations: {
    [SET_STATE] (state, payload) {
      if (!payload) state = defaultState;
      else for (let key in payload) state[key] = payload[key];

      state.anonymous = !state.authToken;
      state.authorized = !!state.authToken;
    }
  },
  actions: {
    async update({ state, commit }, {authToken}) {
      let token = authToken || state.authToken;

      commit(SET_STATE, {authToken});

      if (token) {
        return getUserInfo(token).then(data => {
          commit(SET_STATE, {hasLicense: data.hasLicense, authToken})
        });
      } else {
        commit(SET_STATE, {hasLicense: false, authToken})
      }
    }
  }
};

export default store;
